"use client";
import { Box, Collapse, Stack, SxProps, TableCell, TableRow, Theme } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  open: boolean;
  colSpan?: number;
  content?: ReactNode;
  actions?: ReactNode;
  contentSx?: SxProps<Theme>;
  rowSx?: SxProps<Theme>;
  cellSx?: SxProps<Theme>;
  inline?: boolean;
};

export default function CollapsibleDropdown({
  open,
  colSpan = 6,
  content,
  actions,
  contentSx = { p: 2 },
  rowSx,
  cellSx,
  inline = false
}: Props) {
  const inner = (
    <Collapse in={open}>
      {content && <Box sx={contentSx}>{content}</Box>}
      {actions && (
        <Stack direction="row" sx={{ gap: 1, justifyContent: "center", pt: 1, pb: 2 }}>
          {actions}
        </Stack>
      )}
    </Collapse>
  );

  if (inline) return inner;

  return (
    <TableRow sx={rowSx}>
      <TableCell style={{ minHeight: 0, paddingBottom: 0, paddingTop: 0 }} sx={cellSx} colSpan={colSpan}>
        {inner}
      </TableCell>
    </TableRow>
  );
}
